import { AppContext } from "../../common/AppContext";
import { JobSelectorList } from "../../data/filters/JobSelectorList";
import {
  AbstractFilterSelectProps,
  BaseSelectorOption
} from "../../types/components/selector.types";
import { AbstractFilterSelect } from "./AbstractFilterSelect";

interface JobSelectorOption extends BaseSelectorOption {
  jobDefinitionId?: string | null | number;
}

export class JobSelector<
  TOption extends JobSelectorOption = JobSelectorOption
> extends AbstractFilterSelect<TOption> {
  static contextType = AppContext;

  static defaultProps = {
    ...AbstractFilterSelect.defaultProps,
    label: "Job",
    listType: "Jobs"
  };

  constructor(props: AbstractFilterSelectProps<TOption>) {
    super(props);

    this.dataList = JobSelectorList as unknown as typeof this.dataList;
  }

  getItemId(item: TOption) {
    return item.jobDefinitionId || "";
  }

  getItemLabel(item: TOption) {
    const { getItemLabel } = this.props;

    if (getItemLabel) return getItemLabel(item);
    return item as unknown as string;
  }

  getList(dataList: JobSelectorList) {
    return dataList.jobs;
  }
}
